// Copyright (c) 2016 Deere & Company

import './search-result.scss';
import React, {PropTypes} from 'react';
import {
    buildProductUseAmount,
    buildUseAmount
} from '../../shared/services/product';
import LabeledString from '../../../shared/components/labeled-string';
import PipStatus from './../../shared/components/pip-status';
import ProductImage from './../../../shared/components/product-image';
import ProductLink from '../../shared/components/product-link';
import ProductSearchPopover from './product-search-popover';
import ProductSearchResult from '@deere/cps-it.warranty-model-factory/lib/product-search-results';
import ProductSearchStatusLink from './product-search-status-link';
import WarrantyStatus from './warranty-status';
import {buildDate} from '../../../shared/services/build-date';
import {buildDealer} from '../../../shared/services/build-dealer';

const SearchResult = props => {

    const amountOfUseData = props.product.isSap ?
        buildProductUseAmount(props.product.useAmount, props.product.useAmountLastUpdated) :
        buildUseAmount(props.product.useAmount);

    return (
        <section className='search-result'>
            <section>
                <div className='product-image'>
                    <ProductImage
                        imageURL={props.product.imageUrl}
                        placeHolderText={props.product.baseMachineCode}
                    />
                </div>
                <div className='search-result-body'>
                    <div className='product-header'>
                        <ProductLink
                            isLink={props.product.isSap}
                            pin={props.product.pin}
                            productLinkStyle='product-title'
                            productLinkText={props.product.pin}
                            translate={false}
                        />
                        {props.product.isSap && props.product.pipIndicator.status &&
                            <PipStatus
                                pin={props.product.pin}
                                pipIndicator={props.product.pipIndicator}
                            />
                        }
                    </div>
                    <div className='search-result-data-pairs'>
                        <div className='row'>
                            <LabeledString
                                className='model'
                                data={props.product.model}
                                label='MODEL'
                            />
                            <LabeledString
                                className='customer'
                                data={props.product.customerSummary.displayName}
                                label='CUSTOMER'
                            />
                        </div>
                        <div className='row'>
                            <LabeledString
                                className='base-machine'
                                data={props.product.baseMachineCode}
                                label='BASE_MACHINE'
                            />
                            <LabeledString
                                className='amount-of-use'
                                data={amountOfUseData}
                                label='AMOUNT_OF_USE'
                            />
                            <LabeledString
                                className='registered-date'
                                data={buildDate(props.product.registrationDate)}
                                label='REGISTERED'
                            />
                        </div>
                        <div className='row'>
                            <LabeledString
                                className='dealer'
                                data={buildDealer(props.product.dealer)}
                                label='DEALER'
                            />
                            {props.product.isSap &&
                                <ProductSearchStatusLink
                                    onOpenStatusChangeModal={props.onOpenStatusChangeModal}
                                    product={props.product}
                                />
                            }
                        </div>
                    </div>
                </div>
            </section>
            {props.product.isSap &&
                <footer>
                    <WarrantyStatus hasWarranty={props.product.warranty}/>
                    <section className='button-group'>
                        <ProductSearchPopover
                            onClaimsModalOpen={props.onClaimsModalOpen}
                            pin={props.product.pin}
                            statusList={props.product.status}
                        />
                        <ProductLink
                            pin={props.product.pin}
                            productLinkStyle='primary'
                            productLinkText='VIEW_DETAILS'
                            translate={true}
                        />
                    </section>
                </footer>
            }
        </section>
    );

};

SearchResult.displayName = 'SearchResult';
SearchResult.propTypes = {
    onClaimsModalOpen: PropTypes.func.isRequired,
    onOpenStatusChangeModal: PropTypes.func.isRequired,
    product: PropTypes.instanceOf(ProductSearchResult).isRequired
};

export default SearchResult;



// WEBPACK FOOTER //
// ./src/product/search/components/search-result.js